import PropTypes from 'prop-types'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import { QueryClient, QueryClientProvider } from 'react-query'
// import { ReactQueryDevtools } from 'react-query/devtools'
import App from './App'
import '../styles/core.scss'
import { LexiconContextProvider } from '../contexts/Lexicon'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true
    }
  }
})

const Root = ({ store, history }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <ConnectedRouter history={history}>
            <LexiconContextProvider>
              <App history={history} />
            </LexiconContextProvider>
        </ConnectedRouter>
      </Provider>
      {/*<ReactQueryDevtools initialIsOpen={false} position="top-right" />*/}
    </QueryClientProvider>
  )
}

Root.propTypes = {
  store: PropTypes.object,
  history: PropTypes.object
}

export default Root
